module.exports = __webpack_public_path__ + "static/media/usecase1_persona.17288a46.png";